import React, { FC } from 'react'

const PreviousPositionMarker: FC = () => {
  return (
    <svg
      width="24"
      height="32"
      viewBox="0 0 24 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.12471 22.9465L9.12463 22.9464C4.04435 21.65 0.5 17.1073 0.5 11.9028C0.5 5.61958 5.65551 0.5 12 0.5C18.3445 0.5 23.5 5.61958 23.5 11.9028C23.5 17.0996 19.962 21.6408 14.8909 22.9425C14.6683 22.9996 14.482 23.1255 14.3319 23.2591C14.1798 23.3944 14.04 23.5599 13.9118 23.7328C13.661 24.0713 13.4131 24.4963 13.1769 24.9013L13.1674 24.9176C12.8998 25.3763 12.6504 25.8021 12.4071 26.1158C12.2861 26.2716 12.183 26.378 12.0986 26.4419C12.0434 26.4836 12.0117 26.4957 12.0004 26.499C11.9893 26.4956 11.9584 26.4835 11.9049 26.4428C11.8213 26.3792 11.7189 26.2732 11.5987 26.1175C11.3569 25.8044 11.109 25.3792 10.843 24.9213L10.834 24.9058C10.5988 24.5006 10.3519 24.0752 10.1019 23.7367C9.97432 23.5638 9.83505 23.3983 9.68336 23.263C9.53371 23.1295 9.34752 23.0034 9.12471 22.9465Z"
        fill="white"
        stroke="#979797"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#E6E6E6"
      />
      <mask
        id="mask0"
        type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="20"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)"></g>
      <g filter="url(#filter0_f)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 30C14.2091 30 16 29.3284 16 28.5C16 27.6716 14.2091 27 12 27C9.79086 27 8 27.6716 8 28.5C8 29.3284 9.79086 30 12 30Z"
          fill="#CCCCCC"
        />
      </g>
      <rect
        x="7.89099"
        y="14.6591"
        width="1.06158"
        height="2.19899"
        rx="0.53079"
        fill="#D8D8D8"
        stroke="#4D4D4D"
        strokeWidth="0.644531"
      />
      <rect
        x="14.7155"
        y="14.6591"
        width="1.06158"
        height="2.19899"
        rx="0.53079"
        fill="#D8D8D8"
        stroke="#4D4D4D"
        strokeWidth="0.644531"
      />
      <path
        d="M9.57813 6.6875H14.0898C15.3411 6.6875 16.3555 7.70185 16.3555 8.95313V14.1094C16.3555 15.0047 15.6297 15.7305 14.7344 15.7305H8.93359C8.03829 15.7305 7.3125 15.0047 7.3125 14.1094V8.95312C7.3125 7.70185 8.32685 6.6875 9.57813 6.6875Z"
        fill="#E6E6E6"
        stroke="#4D4D4D"
        strokeWidth="0.625"
      />
      <path
        d="M9.42651 8.39362H14.2415C14.7809 8.39362 15.2181 8.83084 15.2181 9.37018V11.7495H8.44995V9.37018C8.44995 8.83084 8.88717 8.39362 9.42651 8.39362Z"
        fill="white"
        stroke="#4D4D4D"
        strokeWidth="0.625"
      />
      <path
        d="M15.2083 13.4838C15.2083 13.7769 14.9707 14.0146 14.6775 14.0146C14.3844 14.0146 14.1467 13.7769 14.1467 13.4838C14.1467 13.1906 14.3844 12.953 14.6775 12.953C14.9707 12.953 15.2083 13.1906 15.2083 13.4838Z"
        fill="#FFDD00"
        stroke="#4D4D4D"
        strokeWidth="0.644531"
      />
      <path
        d="M9.5213 13.4838C9.5213 13.7769 9.28365 14.0146 8.99051 14.0146C8.69736 14.0146 8.45972 13.7769 8.45972 13.4838C8.45972 13.1906 8.69736 12.953 8.99051 12.953C9.28365 12.953 9.5213 13.1906 9.5213 13.4838Z"
        fill="#FFDD00"
        stroke="#4D4D4D"
        strokeWidth="0.644531"
      />
      <defs>
        <filter
          id="filter0_f"
          x="6.50495"
          y="25.5049"
          width="10.9901"
          height="5.99011"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.747527"
            result="effect1_foregroundBlur"
          />
        </filter>
      </defs>
    </svg>
  )
}

export default PreviousPositionMarker
